import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import SuccessfulDialog from './SuccessfulDialog';
import {DIALOG_TYPES, TYPES} from '../reducers/messages';

const styles = theme => ({
  paperStyle: {
    width: '60%',
  }, 
  captionColor: {
    color: '#A1A1A1'
  }
});

/**
 * Dialog modal window displaying "global" messages from store
 */

const MessagesDialogComponent = ({ open, messages, classes }) => {
  return (
    <React.Fragment>
      {messages.map((message, i) => {
        switch( message.dialogType ) {
            case DIALOG_TYPES.SUBSCRIPTION_REACTIVATION_SUCCESS:
            case DIALOG_TYPES.SUBSCRIPTION_UPDATE_SUCCESS:
            case DIALOG_TYPES.SUBSCRIPTION_SYNC_SUCCESS:
                 return <SuccessfulDialog 
                          classes={classes} 
                          message={message} 
                          open={open} 
                          key={i} />
            default:
              return null;
        }
      })}
   </React.Fragment>

    
  );
}

const mapStateToProps = ({ messages }) => {
  const dialogMessages = messages.filter( message => message.type === TYPES.DIALOG );
  const open = dialogMessages.length > 0;
  
  return {
    open,
    messages: dialogMessages,
  };
}

const MessagesDialog = connect(
    mapStateToProps,
    undefined
  )(MessagesDialogComponent);

export default withStyles(styles)(MessagesDialog);


// WEBPACK FOOTER //
// ./src/components/MessagesDialog.js